import {
  TRAINING_AUTH_ACTION,
  TRAINING_AUTH_ENDPOINT
} from 'modules/training/modules/app-auth/constants'
import saveReduxAction from 'modules/redux/actions/save'
import getEndpointTrainingUtil from 'modules/training/utils/get-endpoint'
import { logUtil } from 'packages/src'

export default function resetPasswordAction (payload) {
  return async (dispatch) => {
    try {
      const response = await dispatch(saveReduxAction({
        type: TRAINING_AUTH_ACTION.RESET_PASSWORD,
        payload: {
          data: payload,
          endpoint: getEndpointTrainingUtil(TRAINING_AUTH_ENDPOINT.RESET_PASSWORD)
        }
      }))

      return response
    } catch (error) {
      logUtil('resetPasswordAction')
        .error('resetPasswordAction: ', error)

      return error
    }
  }
}
